import * as loader from '../requests/loader';
import storage from '../components/DeviceStorage/DeviceStorage';
import Asset from '../requests/apa/Asset';
import Metadata from '../requests/apa/Metadata';
import Launcher from '../requests/apa/Launcher';
import Badges from '../requests/apa/Badges';
import Device from '../devices/device';
import Utils from '../utils/Utils';
import DashboardTracker from '../utils/trackers/DashboardTracker';
import { TimeshiftUtil } from '../AAF/Timeshift/TimeshiftUtil';

/**
 * 
 * @param {*} resp 
 * @returns 
 */
function stringifyLauncherResponse(resp) {
  let _resp = resp;

  if(Utils.isObject(resp)) {
    _resp = JSON.stringify(resp);
  }
  else if(Utils.isNullOrUndefined(resp)) {
    _resp = 'Empty response';
  }
  else if(Utils.isJson(resp)) {
    _resp = JSON.stringify(resp);
  }
  else {
    try {
      _resp = resp + '';
    }
    catch(er) {}
  }

  return _resp;
}

export default async function loadInitApis() {
  /**
   * Orden: https://dlatvarg.atlassian.net/wiki/spaces/DAMCO/pages/204986903/Inicio+de+la+aplicaci+n
   *
   *  mfwks: user/startheaderinfo (sync)
   *  mfwks: apa/metadata (async)
   *  mfwks: apa/asset (async)
   *  mfwks: apa/launcher (async)
   */
  const hks = storage.getItem('HKS');
  const refresh = storage.getItem('refresh');
  if (hks && refresh) {
    storage.setItem('HKS', '');
    storage.unsetItem('refresh');
  }

  const promises = [loader.apaLauncher(), loader.startHeaderInfo()]
  const [apaLauncher] = await Promise.all(promises);
  const region = storage.getItem('region');
  let {response: responseApaLauncher = {} } = apaLauncher || {};

  if (apaLauncher) {
    if (!Utils.isAkamaiMfwkinLauncher(responseApaLauncher)) {
      const {akamai_mfwk = '' }= Device.getDevice().getConfig();
      const akamai_mfwk_hostname = akamai_mfwk.replace(/^(https?|ftp):\/\//, '');

      const akamaiFromConfig = { akamai_mfwk : akamai_mfwk_hostname };
      if(Utils.isObject(responseApaLauncher)) {
        responseApaLauncher = {...responseApaLauncher, ...akamaiFromConfig};
      }
      else {
        responseApaLauncher = { akamai_mfwk : akamai_mfwk_hostname };
      }
      const tracker = new DashboardTracker();
        if (apaLauncher && apaLauncher.code) {
          tracker.trackEpg('akamai_mfwk not exists', 1, {
            msg: `Cannot find Akamai_mfwk in Launcher`,
            stackTrace: '/services/apa/launcher | launcher response: '.concat(stringifyLauncherResponse(apaLauncher)),
          });
        }
    }
    Device.getDevice().update_launcher(region, responseApaLauncher);
    Launcher.setData(responseApaLauncher);
  }

  const [apaMetadata, apaAsset] = await Promise.all([
    loader.apaMetadataMiddleware(),
    loader.apaAsset()
  ]);

  const {badges, ...newApaMetadata} = apaMetadata;

  Metadata.setData(newApaMetadata);
  Asset.setData(apaAsset);
  Badges.set(badges);

  const devicePlatform = TimeshiftUtil.getDevicePlatform();
  if (devicePlatform) {
    const hasTimeshiftSupported = await TimeshiftUtil.hasTimeshiftSupported(devicePlatform);
    if (!hasTimeshiftSupported) {
      console.log("[applicationLoader] Timeshift is not supported", devicePlatform, hasTimeshiftSupported);
      TimeshiftUtil.disableTimeshiftKeys();
    }
  }

  if (apaLauncher) {
    const _region = storage.getItem('region');
    Device.getDevice().update_launcher(_region, responseApaLauncher);
    Launcher.setData(apaLauncher.response);
  }


  return new Promise(resolve => {
    resolve();
  });
}



// WEBPACK FOOTER //
// ./src/config/applicationLoader.js